import { GameTag } from 'config/types'
import { useAppSelector } from 'state'

const useGameTag = (tagCode: string): GameTag => {
  const tags = useAppSelector((state) => state.app.tags)
  return tags?.find((tag) => tag.value == tagCode)
}

export default useGameTag
